import { SettingsRepository } from "../interfaces";
import { SettingsRecord } from "../types";
import { InMemoryStore } from "./store";

export class InMemorySettingsRepository implements SettingsRepository {
  constructor(private store: InMemoryStore) {}

  async get(): Promise<SettingsRecord> {
    return { ...this.store.settings };
  }

  async save(settings: SettingsRecord): Promise<void> {
    this.store.settings = { ...this.store.settings, ...settings, id: this.store.settings.id };
  }
}
